// extracted by mini-css-extract-plugin
module.exports = {"root":"tabs_capsule_root__10Goy"};